import React, {ReactNode, useEffect} from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

type PropsType = {
    children: ReactNode
}

//Page wrapper with common components
function Page({children}: PropsType) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [children]);

    return(
        <>
            <Header/>

            {children}

            <Footer/>
        </>
    )
}

export default Page;